export const playerCommandMessage = code => ({
  ACCOUNT_ALREADY_EXIST: 'An account already uses this email address. Open the existing player instead.',
  OPERATION_PAYLOAD_CONFLICT: 'This operation was already used with different details. Check its saved result.',
  ERROR_PERMISSIONS: 'Your session does not allow this action. Sign in again and check the result.',
  INVITATION_RATE_LIMITED: 'Please wait five minutes between invitation requests.',
  INVITATION_NOT_AVAILABLE: 'This account is no longer eligible for an invitation.',
}[code] || (code?.startsWith('INVALID_PLAYER') ? 'Some details are no longer valid. Review the form and reload its options.'
  : 'The result is not confirmed. Check its status before trying again.'))

export function runPlayerCommand({ accountId, operationId, correlationId, operation = 'player-created', submit, read, socket,
  timeoutMs = 60000, pollMs = 2000, messageForCode = playerCommandMessage, isSuccess = data => data?.status === 'saved' && /^[a-f\d]{24}$/i.test(data.id || '') }) {
  let finished = false, resolve, timer
  const promise = new Promise(done => { resolve = done })
  const finish = data => {
    if (finished) return
    finished = true
    clearTimeout(timer)
    clearTimeout(deadline)
    socket?.off('accounts-response', onResponse)
    resolve(data)
  }
  const accept = data => {
    if (accountId && data?.id && data.id !== accountId) return
    if (isSuccess(data)) finish(data)
    if (data?.status === 'error' && data.message !== 'OPERATION_PAYLOAD_CONFLICT') finish({ ...data, message: messageForCode(data.message), code: data.message })
  }
  const onResponse = response => {
    if (response?.operation !== operation || response.operationId !== operationId || response.correlationId !== correlationId) return
    if (response.success === true) accept(response.data)
    else if (response.success === false && response.retryable === false) accept({ status: 'error', message: response.message })
  }
  const poll = async () => {
    if (finished) return
    try { accept((await read(operationId)).data) } catch { /* An unavailable query does not prove that saving failed. */ }
    if (!finished) timer = setTimeout(poll, pollMs)
  }
  const deadline = setTimeout(() => finish({ status: 'unknown' }), timeoutMs)
  socket?.on('accounts-response', onResponse)
  timer = setTimeout(poll, submit ? pollMs : 0)
  if (submit) Promise.resolve().then(() => !finished && submit()).catch(error => {
    if (error.response?.status >= 400 && error.response.status < 500 && ![401, 403, 408, 429].includes(error.response.status)) {
      accept({ status: 'error', message: error.response.data?.message })
    }
  })
  return { promise, cancel: () => finish({ status: 'cancelled' }) }
}
